<template>
  <div class="quick-nav">
    
    <!-- Administrator Canvate -->
    <div v-if="administrator">
      <div class="wrapper">
        <div class="toptitle">
          <div class="container">
            <h1>Patient Management</h1>
          </div>
        </div>
        <div class="tabs col-sm-12 col-md-12 col-lg-12">
              <div class="ordescriptab" :class="activeTab == 0 ? 'active' : ''">
                <a href="#orderscript" id="ordescripbtn" title="Order Description" @click="activeTab = 0">Patient Management</a>
              </div>
              <div class="medicationtab" :class="activeTab == 1 ? 'active' : ''" :style="{ 'display': 'block' }">
                <a href="#medtab" id="medicationbtn" title="Medications Tab" @click="activeTab = 1;loadProviders();">Providers</a>
              </div>
              <div class="diagnosistab" :class="activeTab == 2 ? 'active' : ''" :style="{ 'display': 'block' }">
                <a href="#diagnosistab" id="diagnosisbtn" title="Diagnosis Tab" @click="activeTab = 2">New Tab</a>
              </div>
              <div class="proctab" :class="activeTab == 3 ? 'active' : ''" :style="{ 'display': 'block' }">
                <a href="#proctab" id="procbtn" title="Procedure Tab" @click="activeTab = 3">New Tab</a>
              </div>
          </div>
       <div class="patientCanvas" :style="[activeTab == 0 ? { 'display': 'block' } : { 'display': 'none' }]">
        <div class="searchfindarea d-none d-lg-block">
          <div class="container">
            <div class="iconfield col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <img
                src="https://cdn3.iconfinder.com/data/icons/doctor-icons/100/01-1Doctor-512.png"
                width="40"
                height="40"
                alt="image"
              />
              <!-- <label name="findprovlbl">Find Provider</label> -->
              <input
                type="text"
                name="findprov"
                class="providfield"
                placeholder="Search for Provider"
              />
            </div>
            <div class="iconfield col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
              <input
                v-model="shareId"
                type="text"
                name="sharePatient"
                class="shareidfield"
                placeholder="Patient ID #"
              />
              <button class="sharePatientBtn" @click="share">Share a patient</button>
            </div>
            <div class="iconfield col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
              <img
                src="https://cdn2.iconfinder.com/data/icons/picol-vector/32/document_text_add-512.png"
                width="40"
                height="40"
                alt="image"
              />
              <!-- <label name="findprovlbl">Register</label> -->
              <!-- <router-link 
                to="/adminregister" 
                class="addPatientBtn">
                  Add a new patient
              </router-link> -->
              <input
                type="button"
                name="addPatient"
                class="addPatientBtn"
                value="Add Patients"
                @click="$router.push('/adminregister')"
              />
            </div>
            <div class="iconfield col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
              <input
                type="checkbox"
                name="filtered"
                class="filteredBtn"
                value="Filtered"
                v-model="filtered"
              />
              <span>Filtered</span>
            </div>
          </div>
        </div>
        <div class="gridarea">
          <div class="container">
            <div class="columntop d-none d-lg-flex">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col1" class="coltext">PID</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col2" class="coltext">Name</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col3" class="coltext">Date of Birth</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Login ID</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Last Upload/DateTime</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col6" class="coltext">Remote</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col7" class="coltext">Communication</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col8" class="coltext">Status</span>
                  </div>
            </div>
            <div class="d-none d-sm-flex d-md-none row">
              <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col2_" class="coltext">Name</span>
              </div>
              <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col3_" class="coltext">Date of Birth</span>
              </div>
              <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col7_" class="coltext">Communication</span>
              </div>
            </div>
            <div
              v-for="(patient,index) in patients"
              class="patientrow"
              :key="'patient' + patient.id + filtered"
            >
              <div class="columnrow columnrowmb row d-sm-none">
                <div class="col-8 top-row">
                  <span
                    @click="getPatientById(patient.id)"
                    id="patientName"
                    class="coltext"
                    >{{ patient.firstName + " " + patient.lastName }}</span
                  >
                </div>
                <div class="col-4 top-row">
                  <span id="patientNote" class="coltext msgiconbtn"
                    ><img
                      title="Write a note"
                      src="https://cdn4.iconfinder.com/data/icons/eon-ecommerce-i-1/32/message_letter_email_mail_send_envelope-512.png"
                      width="40"
                      height="40"
                      @click="showNote(patient.id, index)"
                  /></span>
                  <span id="patientOrder" class="coltext ordericonbtn">
                    <img
                      title="Write an order"
                      src="https://cdn4.iconfinder.com/data/icons/email-2-2/32/Compose-Email-Note-Inquiry-128.png"
                      width="35"
                      height="35"
                      @click="showOrder(patient.id)"
                    />
                  </span>
                </div>
              </div>
              <div class="columnrow columnrowtab d-none d-sm-flex d-md-none">
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <span
                    @click="getPatientById(patient.id)"
                    id="patientName"
                    class="coltext"
                    >{{ patient.firstName + " " + patient.lastName }}</span
                  >
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <span id="patientDob" class="coltext">{{ patient.dob }}</span>
                </div>
                <div class="col-4 top-row">
                  <span id="patientNote" class="coltext msgiconbtn"
                    ><img
                      title="Write a note"
                      src="https://cdn4.iconfinder.com/data/icons/eon-ecommerce-i-1/32/message_letter_email_mail_send_envelope-512.png"
                      width="40"
                      height="40"
                      @click="showNote(patient.id, index)"
                  /></span>
                  <span id="patientOrder" class="coltext ordericonbtn">
                    <img
                      title="Write an order"
                      src="https://cdn4.iconfinder.com/data/icons/email-2-2/32/Compose-Email-Note-Inquiry-128.png"
                      width="35"
                      height="35"
                      @click="showOrder(patient.id)"
                    />
                  </span>
                </div>
              </div>
              <div class="columnrow columnrowpc d-md-flex d-none">
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <span
                    @click="getPatientById(patient.id)"
                    id="patientExtern"
                    class="coltext"
                    >{{ patient.externId }}</span
                  >
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <span
                    @click="getPatientById(patient.id)"
                    id="patientName"
                    class="coltext"
                    >{{ patient.firstName + " " + patient.lastName }}</span
                  >
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <span id="patientDob" class="coltext">{{ patient.dob }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <span id="patientUser" class="coltext">{{ patient.login }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <div v-if="loading" class="loader"></div>
                  <span v-else id="patientUpload" class="coltext">{{
                    latestTimes[patient.id]
                      ? new Date(latestTimes[patient.id]).toLocaleString("en-US", {
                          timeZone: "America/New_York",
                        }) + " EST"
                      : "N/A"
                  }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <span id="patientRemote" class="coltext"
                    ><img
                      v-if="meters && meters[patient.id]"
                      src="https://cdn1.iconfinder.com/data/icons/ionicons-fill-vol-1/512/checkmark-128.png"
                      width="40"
                      height="40"
                  /></span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <span id="patientNote" class="coltext msgiconbtn"
                    ><img
                      title="Write a note"
                      src="https://cdn4.iconfinder.com/data/icons/eon-ecommerce-i-1/32/message_letter_email_mail_send_envelope-512.png"
                      width="40"
                      height="40"
                      @click="showNote(patient.id, index)"
                  /></span>
                  <span id="patientOrder" class="coltext ordericonbtn">
                    <img
                      title="Write an order"
                      src="https://cdn4.iconfinder.com/data/icons/email-2-2/32/Compose-Email-Note-Inquiry-128.png"
                      width="35"
                      height="35"
                      @click="showOrder(patient.id)"
                    />
                  </span>
                  <span id="assignNursetopatient" class="coltext ordericonbtn">
                        <img title="Assign an Nurse"
                          src="https://cdn4.iconfinder.com/data/icons/healthcare-and-medical-29/64/Artboard_20-512.png"
                          width="35" height="35" @click="showNurseModule(patient.externId,patient.externId2,patient.firstName+' '+patient.lastName)" />
                      </span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                  <div
                    class="patientStatus coltext"
                    :class="{ filtered: filtered, active: isActive(patient.id) }"
                    @click="toggleStatus(patient.id)"
                  >
                    {{ patient.active }}
                  </div>
                      
                </div>
              </div>
              <note-popup ref="notePopup" class="note__popup" :type="'Nursing'" :patient="patient" :id="'note__popup' + patient.id"
                      style="display: none" />
                  <order-popup class="order__popup" :patient="patient" :orderNum="orderNum"
                      :id="'order__popup' + patient.id" style="display: none" />
            </div>
            <PickList v-if="assignmentId" v-model="nursesPL" @move-to-source="movingToNursePool($event)" :selection.sync="nurseassigned" :stripedRows="true" listStyle="height:342px" dataKey="pmid">
                 
                 <template #sourceheader>
                     Available
                 </template>
                 <template #targetheader>
                   {{PListPatientName}} <br/>
                   Selected
                 </template>
                 <template #item="slotProps">
                     <div class="product-item">
                         <div class="image-container">
                             <img src="@/assets/images/nurse-avatar.png" alt="nurse image" height="40" width="40" /> 
                         </div>
                         <div class="product-list-detail">
                             <h5 class="mb-2">{{slotProps.item.firstname}} {{slotProps.item.lastname}}</h5>
                             <i class="pi pi-tag product-category-icon"></i>
                             <span class="product-category">License Number: {{slotProps.item.licensenum}}</span>
                         </div>
                         <div class="product-list-action">
                             <h6 class="mb-2">License Type: {{slotProps.item.licensetype}}</h6>
                             <span class="product-badge">Email:{{slotProps.item.email}}</span>
                         </div>
                     </div>
                 </template>
                 
               </PickList>
             <div v-if="assignmentId" class="picklist-close-save button-container">
                   <button class="btn btn-primary button" @click="closeNurseAssigned()" value="CLOSE">CLOSE</button>
                   <button classs="btn btn-secondary button" @click="saveNurseAssigned($event,nursesPL[1])" value="SAVE">SAVE</button>
             </div>
            
            <!--Pageniation Area-->
            <pagination-info ref="pagination-info" />
            <pagination ref="pagination" @pagination:change-page="paginate" />
            <!--End Pagination Area-->
          </div>
          <!--Providers Tab-->
          <div id="providercanvas" :style="[activeTab == 1 ? { 'display': 'block' } : { 'display': 'none' }]">
              <div class="container">
                <h2> Account Providers</h2>
                <ul v-if="allProvs" class="result-list">
                    <li v-for="(provider, index) in allProvs" :key="index">
                        <div class="result-item" :id="'ncard'+provider.licensenum">
                            <h2 class="header3 capitalize">
                                <span v-if="provider.firstname">{{ provider.firstname.toLowerCase() }} </span>
                                <span v-if="provider.lastname">{{ provider.lastname.toLowerCase() }}</span>
                                <div class="modifier-container">
                                    <button class="modifier-indicator" @click="showMod(index)">...</button>
                                    <div class="modifier-dropdown" :id="'modifier-dropdown' + index">
                                        <button class="provbtn edit" @click="showEditProv(provider.licensenum)">Edit</button>
                                        <button class="provbtn remove" @click="removeProvider(provider.licensenum)">Remove</button>
                                      <!-- <button class="provbtn call" @click="callProvider(provider)">Call</button>
                                        <button class="provbtn txt" @click="showTextProv(provider)">Text</button>
                                        <button class="provbtn email" @click.self="showEmailModule($event,index,provider)">Email</button>-->
                                    </div>
                                </div>
                            </h2>
                            <div class="col-sm-12 col-md-12 col-lg-12 status-nonactive" :id="'vstatus'+provider.licensenum">
                                <p>License Status Not Active</p>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 status-active" :id="'vstatus2'+provider.licensenum">
                                <p>License Status Active</p>
                            </div>
                            <!-- TODO: is it a good idea to pick the first entry?  -->
                            <!-- <provider-bio :provider="provider" :specialty="provider.specialties[0].name" :keywords="keywords"></provider-bio> -->
                            <div class="emailcanvas" :id="'emailcanvas'+provider.providerid">
                                <div class="container">

                                    <label>Email:<span id="cllprov">Joseph Mulvehill</span></label><br/>
                                    <!--<label>To:</label><input type="text" id="providetomail" class="provid-inputfield"/><br/>-->
                                    <label>To:</label><input type="text" :id="'providetomail'+provider.providerid" class="provid-inputfield">
                                    <div class="inputvalholder">
                                        <!--<li class="emailli">
                                            <div class="emailblock">
                                                <a href="mailto:keyonwhiteisde@willowmarketing.com" id="emaillink">keyon5052@gmail.com</a>
                                                <span class="xout">X</span>
                                            </div>
                                        </li>
                                        <li class="emailli">
                                            <div class="emailblock">
                                                <a href="mailto:keyonwhiteisde@willowmarketing.com" id="emaillink">emailvip52@gmail.com</a>
                                                <span class="xout">X</span>
                                            </div>
                                        </li>-->
                                    </div>
                                    <ul class="selectbox">
                                        <!--<li class="emailbox">
                                            <p id="selectemailp">Keyon@gmail.com</p>
                                            <div id="hiddenmail"></div>
                                        </li>-->
                                    </ul>
                                    <br/>
                                    <label>Subject:</label><input type="text" :id="'provemailsubject'+provider.providerid" class="provid-inputfield"/><br>
                                    <label>Message:</label><br/>
                                    <textarea :id="'provid-emailmsg'+provider.providerid" placeholder="Provider Message">

                                    </textarea><br/>
                                    <div class="btn-container">
                                        <input type="button" class="btn btn-danger" value="Send Email" @click="SendProvEmail(provider,index)" id="sendprovid-emailbtn"/>
                                        <input type="button" class="btn btn-secondary" value="Close Email" @click="CloseProvEmail(provider.providerid)" id="closeprovid-emailbtn"/>
                                        <input type="hidden" id="sendprovider" value=""/>
                                    
                                    </div>
                                
                                </div>
                        </div>
                        
                        <account-nurse-bio :provider="provider"></account-nurse-bio>
                           
                        </div>
                    </li>
                </ul>
               
              </div>
          </div>
          <!--End Provider section-->
      </div>
      </div>
      <!---<pagination-info ref="pagination-info" />
      <pagination ref="pagination" @pagination:change-page="paginate" />-->
      <!-- <ul class="quick-nav__list">
        <li class="quick-nav__item" aria-label="medical reports">
          <div v-if="administrator" class="item__title">
            <font-awesome-icon icon="file-medical" class="icon"/>
            <p class="item__subtitle">Register</p>
            <router-link to="/adminregister" class="item__link">Add a new patient</router-link>
            
            <div class="item__link__group">
              <input v-model="shareId" id="add__externId" class="item__link" type="text" placeholder="Patient ID #">
              <button class="item__link existing__link" @click="share">Share a patient</button>
            </div>
          </div>
        </li>

        <li class="quick-nav__item" aria-label="health records">
          <div v-if="administrator" class="item__title">
            <font-awesome-icon icon="file-medical-alt" class="icon"/>
            <p class="item__subtitle">Patients</p>
            <div v-if="relations.length===0" class="item__link">No patients added</div>
            <relations-list-dropdown v-else/>
          </div>
        </li>
      </ul> -->
    </div>
    </div>
    <div v-if="!administrator">
      <welcome-health-records />
    </div>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import OrderPopup from "@/components/private-layouts/OrderPopup.vue";
import NotePopup from "@/components/private-layouts/NotePopup.vue";
import WelcomeHealthRecords from "./WelcomeHealthRecords.vue";
import WelcomeQuickNavSearch from "./WelcomeQuickNavSearch";
import $ from "jquery";
import {
  getAdministrator,
  getRelations,
  getFormattedRelationsList,
  getFormattedMeters,
} from "@/data/getters";
import RelationsListDropdown from "@/components/includes/relations/RelationsListDropdown";
import { mapGetters, mapActions } from "vuex";
import { summaryByExternalId, acquireByExternalId, impersonate } from "@/api/sessionApi";
import { getLatestTime } from "@/api/dataApi";
import { getPreferences, updatePreferences } from "@/api/userApi";


import Pagination from '@/components/includes/pagination/Pagination';
import PaginationInfo from '@/components/includes/pagination/PaginationInfo';
import AccountNurseBio from '../welcome/AccountNurseBio';
import _ from 'lodash';
//import PrimeVue from 'primevue/config';
//import PickList from 'primevue/picklist';
//import 'primevue/resources/themes/lara-light-indigo/theme.css';
//import 'primevue/resources/primevue.min.css';
//import 'primeicons/primeicons.css';

export default {
  name: "WelcomeQuickNav",
  data() {
    return {
      assignmentId: null,
      shareId: "",
      allProvs: null,
      activeTab: 0, // Switch that focuses on right tab; 0 == order, 1 == medications, 2 == diagnosis, 3 == procedure
      patients: [],
      nursesPL: null,
      PListPatientName:null,
      nurses: [],
      nurseassigned:[],
      nursename:"", 
      patId:"",
      accountId:"",
      contents: [[
      {
        id: 341,
        order_id: 1,
        name: "susan",
        information: "inf context",
      },
      {
        id: 453,
        order_id: 2,
        name: "jack",
        information: "info context",
      }], []
    ],
      latestTimes: {},
      loading: true,
      filtered: true,
      filterList: [], 
      itemsPerPage: 10,
      preferences: {},
      orderNum: null,
    };
  },
  props: {
      provider: Object,
      
    },
  watch: {
    filtered() {
      this.paginate(1);
    },
    filterList(newList) {
      let i;
      for (i = 0; i < this.patients.length; i++) {
        this.patients[i].active = !_.includes(newList, this.patients[i].id)
          ? "Active"
          : "Invacive";
      }
    },
  },
  components: {
    "quick-nav-search": WelcomeQuickNavSearch,
    "relations-list-dropdown": RelationsListDropdown,
    "welcome-health-records": WelcomeHealthRecords,
    "order-popup": OrderPopup,
    "note-popup": NotePopup,
    'account-nurse-bio': AccountNurseBio,
    Pagination,
    PaginationInfo,
  },
  
  async mounted() {
    let that = this;
    getPreferences().then((data) => {
      that.$set(that, "preferences", data);
      let paginate = that.filterList === null;
      that.$set(that, "filterList", data.provider_filter);
      that.paginate(1);
    });
    this.paginate(1);

    let res = await getLatestTime({});
    res.forEach((upload) => {
      that.$set(that.latestTimes, upload.who, upload.when);
    });
    this.loading = false;
    // this.showNurseModule(1);
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    administrator: function () {
      // console.log(this.allData);
      // console.log(getRelations(this.allData));
      // console.log(getFormattedRelationsList(this.allData));
      // console.log(this.latestTimes)
      return getAdministrator(this.allData);
    },
    relations: function () {
      return getRelations(this.allData);
    },
    patientList: function () {
      if (this.filterList === null) return null;
      let that = this;
      let result = getFormattedRelationsList(this.allData);
      result = result.map((relation) =>
        _.extend(
          { active: !_.includes(that.filterList, relation.id) ? "Active" : "Invacive" },
          relation
        )
      );
      result.shift();
      if (this.filtered) {
        result = _.filter(
          result,
          (relation) => !_.includes(that.filterList, relation.id)
        );
      }
      let finalResult = result.filter((patient) => !(patient.admin))
      return finalResult;
    },
    meters: function () {
      return getFormattedMeters(this.allData);
    },
  },
  methods: {
    ...mapActions("login", ["updateApplicationModel"]),
    isActive(id) {
      return !(this.filterList && _.includes(this.filterList, id));
    },
    toggleStatus(id) {
      if (this.filtered) return;
      if (_.includes(this.filterList, id)) {
        let fi = _.indexOf(this.filterList, id);
        this.$delete(this.filterList, fi);
      } else {
        this.filterList.push(id);
      }
      this.preferences.provider_filter = this.filterList;
      updatePreferences(this.preferences);
    },
    showNote(id, index) {
      let note = document.getElementById("note__popup" + id);
      note.style.display = "flex";
      this.$refs.notePopup[index].startTimer()
    },
    
    async loadProviders() {
            let content = {
                NursyInfo: {
                    API_Meth: "GetAccountNurse",
                    accountnumber:this.allData.patient.externId2
                }
            }
            await axios
                .post(CURR_API + "/tswebhook.php", content, {
                    headers: { "Content-Type": "application/json;" },
                })
                .then((res) => {
                    console.log(res);
                    if (res.data) {
                        this.allProvs = res.data.nurseInfo
                    } else {
                        this.allProvs = null;
                    }
                });
    },
    movingToNursePool(event)
    {
      console.log(event);
     
      console.log(this.nursesPL);
      let targetSourceItems =event.items;
      let insourcepmid ="";
      let nursename = "";
      for(var i=0;i < event.items.length;i++)
      {
          nursename = targetSourceItems[i].firstname + " "+targetSourceItems[i].lastname;
          insourcepmid = targetSourceItems[i].pmid;
      }
      if(this.nursesPL[0].length >0)
      {
        //filter the nursesPL

        for(var p=0; p < this.nursesPL[0].length;p++)
       {
        if(this.nursesPL[0][p].firstname+ " "+this.nursesPL[0][p].lastname==nursename && this.nursesPL[0][p].pmid==insourcepmid)
        {
         // alert("Remove this one"+nursename);
          this.nursesPL[0].splice(p,1);
        }
       }
        //console.log(this.nursesPL[0].filter((value,index) => this.nursesPL[0].indexOf(value) ==index));
        this.nursesPL[0].filter((value,index) =>this.nursesPL[0].indexOf(value)==index);
       
       //now loop through nursesPL and remove the item that matches nursename 
       
        console.log(insourcepmid);
        console.log(nursename);
      }
    },
    async showOrder(id) {
      let content = {
        systemData: {
          API_Meth: "GetOrderNumber",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          let num = res.data.ordernumber;
          if (num && num != "") {
            this.orderNum = num;
            let order = document.getElementById("order__popup" + id);
            order.style.display = "flex";
          } else
            alert(
              "Error generating order number. Contact an administrator before creating a new order."
            );
        });
    },
    async showNurseModule(id,id2,patientName) {
      console.log(this.allData.patient);
      console.log(id); //unique IDentifer
      console.log(id2); //account number
      //set Pateint Name 
      this.PListPatientName = patientName;
      this.assignmentId = id;
      this.patId = id;
      this.accountId = id2;
      let content = {
        "NursyInfo": {
          "API_Meth": "GetAccountNurse",
          "action":"GetNursesAssigned",
          "patientid":id,
          "accountnumber":id2//this.allData.patient.externId2
        }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
        .then((res) => {
          console.log(res);
          this.nurses = res.data.nurseInfo;
         console.log(res.data);
          this.nursesPL = [res.data.nurseInfo,res.data.nurseassignmentInfo];
          if (this.nurses && this.nurses != '') {
           
            console.log(this.nurses);
          }
          else
            alert("Issue with paypack.");
        })
        .catch((res) => {
          console.log(res);
        })
      
    },
    //try to get nursePL second array items to find the id of the undefined
    findPickListID(name)
    {
      console.log("Inside the find PickListID section");
      let spltname = name.split(" ");
      console.log(spltname);
      let fname =spltname[0];
      let lname = spltname[1];
      let nwar = this.nursesPL[1];
      let providerID =null;
      for(let t=0; t < nwar.length;t++)
      {
        let constructname = fname+ " "+lname;
        if(constructname == nwar[t].firstname + " "+nwar[t].lastname)
        {
          //lets get the id 
          providerID = nwar[t].pmid;
          return providerID;
        }
      }
    },
    closeNurseAssigned()
    {
      this.assignmentId=null;
    },
     saveNurseAssigned(e,selectAr)
   {
     // alert("Button Clicked");
     e.preventDefault();
      console.log(selectAr);
      let nursetoassign =[];
      for(let i=0; i < selectAr.length;i++)
      {
        let firstname = selectAr[i].firstname;
        let lastname = selectAr[i].lastname;
        let providerID = selectAr[i].providerID;
       /* if(providerID==undefined)
        {
          let providerID = this.findPickListID(firstname +" "+lastname);
          console.log(providerID +" "+"This is the nwe PID");
        }*/
        nursetoassign.push(providerID+"-"+firstname + " "+ lastname);
      }
     // console.log(nursetoassign);
     
      this.AssignNurses(nursetoassign,this.patId,this.accountId);
      
    },
    async AssignNurses(nurseAr,pid,accntid)
    {
      let patientID = pid;
      let acntID = accntid;
      let content = {
        "NursyInfo": {
          "API_Meth": "AssigNurseToPatient",
          "patientid":patientID,
          "accountnumber":acntID,
          "nurseInfo": nurseAr
        }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
        .then((res) => {
          console.log(res);
          let message = res.data.message;
          if(message=="Nurse Assigned Successfully")
          {
            //lets check to see if they were assigned and/or discharged 
             let msg ="Nurse(s):";
            if(res.data.nurseInfo.length >0)
            {
             
              for(var t=0; t < res.data.nurseInfo.length;t++)
              {
                msg +=" "+res.data.nurseInfo[t] +", ";
              }
              msg +="were assigned to the patient successfully!";
              alert(msg);
            }
            else if(res.data.dischargeInfo.length >0)
            {

              msg +=" THe following Nurse(s) were discharged from the patient:";
              for(var j=0; j < res.data.dischargeInfo.length;j++)
              {
                console.log(res.data.dischargeInfo[j]);
                msg +=" "+res.data.dischargeInfo[j]+", ";
              }
              msg +="/n Thank You.";
              alert(msg);
            }
            else{
              alert("Data was updated, but please verify for your records");
            }
            

          }
          else if(message=="Nurse(s) Already Assigned")
          {
            alert("Nurse(s) Already Assigned to the Patient");
          }
          else{
            alert("Nurse Not Assigned Successfully,Please try again or contact your system Administrator");
          }
         })
        .catch((err) => {
          console.log(err);
        })
    },
    pageFactory(page, totalPages) {
      console.log("pageFactatory page=" + page + ",totalPages=" + totalPages);
      const pagination = {};
      pagination.from = this.itemsPerPage * (page - 1) + 1;
      pagination.to = Math.min(this.patientList.length, this.itemsPerPage * page);
      pagination.currentPage = page;
      pagination.total = this.patientList.length;
      pagination.totalPage = totalPages;

      this.$refs["pagination-info"].setPaginationData(pagination);
      this.$refs["pagination"].setPaginationData(pagination);
    },
    paginate(curPage) {
      if (this.patientList.length === 0) {
        this.$set(this, "patients", []);
        if (this.$refs["pagination-info"])
          this.$refs["pagination-info"].setPaginationData(null);
        if (this.$refs["pagination"]) this.$refs["pagination"].setPaginationData(null);
        return;
      }
      let tot = Math.ceil((this.patientList || []).length / this.itemsPerPage);
      if (curPage < tot) {
        this.$set(
          this,
          "patients",
          this.patientList.slice(
            this.itemsPerPage * (curPage - 1),
            this.itemsPerPage * curPage
          )
        );
        // this.patients = this.patientList.slice(this.itemsPerPage * (curPage - 1), this.itemsPerPage * curPage)
        this.pageFactory(curPage, tot);
      }
      if (curPage == tot) {
        this.$set(
          this,
          "patients",
          this.patientList.slice(this.itemsPerPage * (curPage - 1))
        );
        // this.patients = this.patientList.slice(this.itemsPerPage * (curPage - 1))
        this.pageFactory(curPage, tot);
      }
    },
    getPatientById(id) {
      console.log("Keyon Test ID"+" "+id);
      //return;
      try {
        let loader = this.$loading.show(
          {},
          {
            after: this.$createElement("div", {}, ["Switching accounts..."]),
          }
        );
        id = parseInt(id);
        impersonate(id)
          .then(() => {
            window.location.hash = "null";
            window.location.reload();
          })
          .catch((e) => {
            console.log(e);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          });
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    },
    share() {
      if (!this.shareId) {
        alert("Please enter a Patient ID # first");
        return;
      }
      let loader = this.$loading.show(
        {},
        {
          after: this.$createElement("div", {}, ["Sharing patient..."]),
        }
      );
      summaryByExternalId(this.shareId).then((res) => {
        if (res.data.error) {
          alert("Patient with ID " + this.shareId + " not found.");
          loader.hide();
          loader = null;
        } else {
          if (
            confirm(
              "Is the patient you are trying to share " +
                res.data.first +
                " " +
                res.data.last +
                " with date of birth " +
                res.data.dob +
                "?"
            )
          ) {
            acquireByExternalId(this.shareId).then((res2) => {
              if (res2.data.error) {
                alert(
                  "This patient has already been shared. Please check your patient list."
                );
              } else {
                if (
                  !alert(
                    "Patient " +
                      res.data.first +
                      " " +
                      res.data.last +
                      ", ID " +
                      this.shareId +
                      ", has been added to your patient list."
                  )
                ) {
                  window.location.reload();
                }
              }
            });
          }
          loader.hide();
          loader = null;
        }
      });
    },
  }, //@import "../../../stylesheets/keyon";
};
</script>

<style lang="scss">
@import "../../../stylesheets/mixins/flex";
$color-base: #0060ff;
$color-font: #58595b;

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

p {
  margin: 0;
}

a {
  color: #000;
}

.quick-nav {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 2em auto;
  max-width: 1500px;
  text-align: center;
  // padding-bottom: 2em;
}

// .header {
//   text-align: center;
//   color: #fff;
//   font-size: 1.2em;
//   padding: 5px 0;
//   background-color: #007bff;
//   margin-bottom: 0px;
// }
.quick-nav__list {
  @include flex-box();
  margin: 40px 0;
}
.nurseBox-left{
  display:flex;
  flex-direction: column;
  width:320px;
  height:auto;
  padding-bottom:10px;
  border-color:#000000;
  border-style:solid;
  border-width:1px;
}
.nurseBox-right{
  display:flex;
  flex-direction: column;
  width:320px;
  height:auto;
  padding-bottom:10px;
  border-color:#000000;
  border-style:solid;
  border-width:1px;
}
.nursemodule{
  display:flex;
  flex-wrap:wrap;
  width:100%;
  height:auto;
  align-items:stretch;
}
.nurse-items:hover{
  background-color:rgb(184, 245, 196);
}
.quick-nav__item {
  @include flex(1, 0, 45%);
  width: 350px;
  padding: 0 20px;
}
.picklist-close-save{
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  padding-right: 82px;
  padding-top: 20px;
}
.item__subtitle {
  padding: 5px 0;
  font-weight: bold;
}

.item__explanation {
  color: gray;
  font-size: 0.9em;
}

.item__link {
  display: block;
  width: 100%;
  // background-color: #007bff;
  color: #fff;
  font-size: 0.8em;
  border-radius: 3px;
  padding: 5px 0;
  margin-top: 10px;
}

.item__link__group {
  display: flex;
}

.existing__link {
  width: 50%;
  border: none;
}

#add__externId {
  color: black;
  background-color: white;
  width: 45%;
  margin-right: 20px;
  text-align: center;
}

.icon {
  font-size: 2em;
}

.loader {
  margin: 0 auto;
  border: 5px solid #f3f3f3;
  /* Light grey */
  border-top: 5px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 768px) {
  .quick-nav {
    margin-bottom: 0;
  }

  .quick-nav__list {
    flex-direction: column;
  }

  .quick-nav__item {
    @include flex(1, 1, auto);
    width: 100%;
    padding: 0 20px;

    &:first-child {
      margin-bottom: 20px;
    }
  }
}

.sharePatientBtn {
  background-color: #165891;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  width: 220px;
}

.patientStatus:not(.filtered) {
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.patientStatus:not(.filtered):hover {
  border: 1px solid rgba(0, 0, 0, 0.5);
  background-color: rgb(204, 204, 255);
}

.patientStatus:not(.filtered):not(.active) {
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.7);
  margin-top: 2px;
}

#patientStatus:not(.filtered).active {
  margin-top: 5px;
}

#patientExtern,
#patientName {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
/*Adding Styles for Provider Card here */
.header3{
  text-align: center;
color: #fff;
font-size: 1.2em;
padding: 5px 0;
background-color: #007bff;
}
.status-nonactive{
  display: none;
background-color: #f12f4f;
color: #ffffff;
font-size: 17px;
}
.status-active{
  display: none;
background-color: #70a50d;
color: #ffffff;
font-size: 17px;
}
.result-list {
    width: 700px;
}
.result-item-link {
    display: block;
    text-align: right;
    font-size: 0.85em;
}

ul {
    list-style-type: none;
    margin: 0 auto;
}
#nursetype{
    margin-bottom:10px;
}
.provcardSec{
    display:none;
    align-items: center;
    position: relative;
    flex-direction: column;
}
.emailcanvas{
    display:none;
   

}

#cllprov{
    margin-left:20px;
}
#providetomail{
    margin-left:30px;
}
#provemailsubject{
    margin-left:30px;
}
#provid-emailmsg{
    margin-left: 30px;
    margin-top: -10px;
    margin-bottom: 10px;
    width: 400px;
    height: 100px;
}
#sendprovid-emailbtn{
    margin-left:30px;
}
.emailcanvas .container{
    box-shadow: 1px 1px 9px #5f5852;
    position:absolute;
    background-color:#ffffff;
    width: 855px;
    height:auto;// 710px;
    padding-bottom:20px;
    margin:0 auto;
    
}
.emailcanvas .btn-container{
    padding-bottom:30px;
}
.emailcanvas label{
    margin-bottom:20px;
}
#providetomail{
    margin-left:30px;
}
.emailcanvas ul{
    display:flex;
    margin-top:-64px;
}
.emailcanvas .emailli{
        list-style: none;
    margin-left: 20px;
}
.emailcanvas .emailblock{
    background-color:#aaabac;
    padding: 5px 5px;
    width: auto;
    height: auto;
    margin-left:12px;
    position: relative;
    top: 17px;
}
.emailcanvas .xout{
    background-color: white;
    cursor: pointer;
}
.mmailbox{
    background-color:#55555512;
    width:100%;
        position: relative;
    z-index: 3000000000;
    top: -35px;
}
.mmailbox #hiddenmail{
    display:none;
}
.emailcanvas .selectbox{
    margin-top:-10px;
}
.inputvalholder{
    display:none;
    justify-content: flex-start;
}
.p-picklist{
    width: 75%;
position: relative;
top: -400px;
background-color: #5d6262;
margin: 0 auto;
border-style: solid;
border-width: 2px;
}
.p-picklist-buttons{
    background-color:#000000;
}
body .p-picklist .p-picklist-header{
    background:#546cc3;
    color:#ffffff;
}
body .p-picklist .p-picklist-list .p-picklist-item{
    background:#fff;
    color:#000;
}
.p-picklist-buttons .p-button{
  background:#000000;
  border-color:#ffffff;
  color:#ffffff;
}
.picklist-close-save{
  position: relative;
  top: -400px;
  padding-right:172px;
}
</style>
